(function (angular) {
    'use strict';

    angular.module('app')
        .controller('resizeImageController', resizeImageController);

    resizeImageController.$inject = [
        '$scope',
        '$uibModalInstance',
        'originalImage',
        'resizeOptions',
    ];

    function resizeImageController(
        $scope,
        $uibModalInstance,
        originalImage,
        resizeOptions
    ) {
        var vm = this;

        // properties
        vm.originalImage = originalImage;
        vm.resizedImage = null;
        vm.resizeOptions = angular.merge({
            shape: 'square',
            size: {
                w: 200,
                h: 200
            },
            aspectRatio: 1
        }, resizeOptions);

        // methods
        vm.close = close;
        vm.resize = resize;

        /**
         * Dismiss when clicking the close button
         * @return {[type]} [description]
         */
        function close() {
            vm.canClose = true;
            $uibModalInstance.dismiss();
        }

        /**
         * Passes resized image back to the parent controller
         * @return {void}
         */
        function resize() {
            $uibModalInstance.close(vm.resizedImage);
        }

        // Catch the modal being closed for any reason
        $scope.$on('modal.closing', function (event, reason, closed) {
            if (!closed && !vm.canClose) {
                event.preventDefault();
            }
        });

    }

}(angular));
